import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/variables';
import { IItemsType } from './types';

const SelectViewWrapper = styled.div`
  position: relative;
  width: 90px;
  &:before {
    content: "";
    position: absolute;
    right: 8px;
    top: 11px;
    border: solid ${colors.gray800};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 2px;
    transform: rotate(45deg);
  }
`;

const SelectView = styled.select`
  width: 90px;
  height: 32px;
  background-color: transparent;
  font-size: 16px;
  padding: 2px 16px 3px;
  border: 1px solid ${colors.gray300};
  border-radius: 2px;
  -webkit-appearance:none;
  outline: none;
`;

const OrderItemNumberSelect = ({ handleChange, selectedNumber, propKey, index, itemsType, max }:
  { handleChange: (event: React.ChangeEvent) => void,
    selectedNumber: number,
    propKey: string,
    index: number,
    itemsType: IItemsType
    max?: number }) => {

  const limit = 10;
  const options = [];

  for (let i = 0; i <= limit; i++) {
    const isDisabled = max && i > max;
    options.push(<option disabled={isDisabled} key={`${name}-${i}`}>{i}</option>);
  }
  return (
    <SelectViewWrapper>
      <SelectView
        onChange={handleChange}
        value={selectedNumber}
        data-items-type={itemsType}
        data-prop-key={propKey}
        data-index={index}>
        {options}
      </SelectView>
    </SelectViewWrapper>
  );
}

export default OrderItemNumberSelect;


